import { connect } from 'react-redux';
import urlsService from '@/services/urls-service';
import { FilterBadges } from '@/components/FilterBadges/FilterBadges';
import { selectFilterBadges } from '../stores/selectors';
import { getProducts } from '../stores/productSearchSlice';
import type { IBadge } from '@components/FilterBadges/FilterBadges';

export const mapStateToProps = (state: any, ownProps?: any) => {
  const activeFilters = selectFilterBadges(state);

  const badges = activeFilters || [];
  return {
    ...ownProps,
    items: badges,
    phrases: ownProps?.phrases ?? {}
  };
};

export const mapDispatchToProps = (dispatch: any) => {
  return {
    onFilterBadgeClick: (badge: IBadge) => {
      const apiUrl = urlsService.getUrl(badge.urlSet.api);
      return getProducts(dispatch)({ apiUrl });
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterBadges);
